export const checkIfMyLock = (processLock = {}) => !!processLock?.createdBy && !processLock?.isMyLock;
